export default function WeStrong(){
    return (
        <div className="strong">
        <h3 className="wow bounceIn">We&rsquo;re Strong</h3>
        <p className="wow bounceIn">SRP Infotech is your one-stop destination for top-notch Website &amp; Application Development
          solutions. We help you get go digital and unlock your business potential.</p>
        </div>
    )
}